import { mapState, mapActions } from "vuex";
import { showError, showSnackBar } from "@/helpers/globalHelpers";
import ObservedEvidenceDialog from '../components/observedDialog';
import EvidenceActionPlanDetailDialog from '../components/evidenceActionPlanDetail';
import moment from "moment";
export default {
  name: "DetailEvidenceActionPlan",
  data() {
    return {
      isLoading: false,
      loadingApproveEvidence: false,
      loadingObserveEvidence: false,
      observedEvidenceDialog: false,
      selectedItem :null,
      detailEvidenceDialog: false,
    }
  },

  computed: {
    breadcrumbs() {
      return this.$route.params.source === 'evidenceActionPlan' ?
        [
          {
            text: "Inicio",
            link: true,
            exact: true,
            disabled: false,
            to: {
              name: "Dashboard",
            },
          },
          {
            text: "Lista de planes de acción por servicio",
            link: true,
            exact: true,
            disabled: false,
            to: {
              name: "ReportActionPlans",
            },
          },
          {
            text: "Lista de evidencias de plan de acción",
            link: true,
            exact: true,
            disabled: false,
            to: {
              name: 'ListEvidenceActionPlan'
            },
          },
          {
            text: "Detalle de evidencia de plan de acción",
            link: true,
            exact: true,
            disabled: true,

          },
        ] :
        [
          {
            text: "Inicio",
            link: true,
            exact: true,
            disabled: false,
            to: {
              name: "Dashboard",
            },
          },
          {
            text: "Lista de planes de acción por servicio",
            link: true,
            exact: true,
            disabled: false,
            to: {
              name: "ReportActionPlans",
            },
          },
          {
            text: "Detalle de agrupación de planes de acción por servicio",
            link: true,
            exact: true,
            disabled: false,
            to: {
              name: "DetailActionPlanGroupedService",
              params: { serviceId: this.$route.params.serviceId }
            },
          },
          {
            text: "Detalle de plan de acción",
            link: true,
            exact: true,
            disabled: false,
            to: {
              name: 'DetailActionPlan',
              params: { serviceId: this.$route.params.serviceId, actionPlanId: this.$route.params.actionPlanId }
            },
          },
          {
            text: "Detalle de evidencia de plan de acción",
            link: true,
            exact: true,
            disabled: true,

          },
        ];
    },
    ...mapState("evidence_action_plan", ["evidenceActionPlan"]),
    evidenceObservedData(){
      if(this.evidenceActionPlan?.status === 'OBSERVADO' && this.evidenceActionPlan?.evidence_action_plan_history_status && this.evidenceActionPlan?.evidence_action_plan_history_status.length){
       
        const length = this.evidenceActionPlan?.evidence_action_plan_history_status.length;
  
        const evidenceActionPlanObserved = this.evidenceActionPlan?.evidence_action_plan_history_status[length-1];
     
        return evidenceActionPlanObserved;
      }else{
        return null;
      }
    }
  },

  created() {
    this.getEvidenceActionPlan();
  },

  methods: {
    ...mapActions("evidence_action_plan", ["getEvidenceActionPlanById", "cleanEvidenceActionPlanId", "confirmEvidenceActionPlan"]),

    async getEvidenceActionPlan() {
      this.isLoading = true;
      const { evidenceActionPlanId } = this.$route.params;
      const { error } = await this.getEvidenceActionPlanById(evidenceActionPlanId);
      if (error) showError(error);
      this.isLoading = false;
    },

    formatDate(dateString) {
      // if (!dateString) {
      //   return { dateOnly: "-", isToday: false };
      // }
      // const formattedDateTime = moment(dateString).format("DD/MM/YYYY HH:mm");
      // const dateOnly = formattedDateTime.split(" ")[0];
      // const isToday = moment().format("DD/MM/YYYY") === dateOnly; // Comparar con la fecha actual

      // return { dateOnly, isToday };

      if (!dateString) {
        return "-";
      }
      // Trata la fecha como un objeto de fecha pura sin conversión de zona horaria
      const dateOnly = moment.utc(dateString).format("DD/MM/YYYY");

      return dateOnly;
    },

    observedEvidence() {
      // this.editedItem = Object.assign({}, item);
      this.observedEvidenceDialog = true;
      this.$nextTick(() => {
        document.activeElement.blur();
      });
    },

    async handleConfirmObserved(data) {
      this.loadingObserveEvidence = true;
      const { error } = await this.confirmEvidenceActionPlan(data);
      this.loadingObserveEvidence = false;
      if (error) {
        let errorMsm = error?.data?.message;
        errorMsm = Array.isArray(errorMsm) ? errorMsm.join(" <br> ") : errorMsm;
        showSnackBar(errorMsm, "error");
        return;
      }
      this.$swal.fire({
        title: "Evidencia observada con éxito",
        icon: "success",
        confirmButtonColor: "#0039a6",
        confirmButtonText: "Ok",
      }).then(() => {
        this.$router.push({ name: 'ListEvidenceActionPlan', params: { planTypeId: this.evidenceActionPlan.action_plan.plan_type_id } });
      });
    },

    confirmEvidence() {
      this.$swal({
        text: '¿Estás seguro de aprobar esta evidencia?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#0039a6',
        cancelButtonColor: 'grey',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí',
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loadingApproveEvidence = true;
          const { evidenceActionPlanId } = this.$route.params;
          const data = {
            company_id: parseInt(localStorage.getItem("company_id")),
            evidence_action_plan_id: evidenceActionPlanId,
            observed: false
          }

          const { error } = await this.confirmEvidenceActionPlan(data);
          this.loadingApproveEvidence = false;
          if (error) {
            let errorMsm = error?.data?.message;
            errorMsm = Array.isArray(errorMsm) ? errorMsm.join(" <br> ") : errorMsm;
            showSnackBar(errorMsm, "error");
            return;
          }
          this.$swal.fire({
            title: "Evidencia aprobada con éxito",
            icon: "success",
            confirmButtonColor: "#0039a6",
            confirmButtonText: "Ok",
          }).then(() => {
            this.$router.push({ name: 'ListEvidenceActionPlan',
                  params: {planTypeId: this.evidenceActionPlan.action_plan.plan_type_id}});
          });
        }
      })
    },

    isAllowed(module, page, activityName) {

      const activities = this.$store.state.auth.activities || [];
      const found = activities.some(
        (activity) =>
          activity.module_name === module &&
          activity.page_name === page &&
          activity.activity_name === activityName
      );

      return found;
    },

    detailEvidence() {
      this.selectedItem = this.evidenceActionPlan;
      this.detailEvidenceDialog = true;
      this.$nextTick(() => {
        document.activeElement.blur();
      });
    },

    setColorStatusEvidenceActionPlan(status) {
      switch (status) {
        case "EN_CURSO":
          return {
            background: "blue lighten-5",
            color: "blue",
            name: "EN CURSO",
          };
        case "COMPLETADO":
          return {
            background: "green lighten-5",
            color: "green",
            name: status,
          };
        case "ATRASADO":
          return {
            background: "grey lighten-3",
            color: "grey",
            name: status,
          };
        case "NO_COMPLETADO":
          return {
            background: "grey lighten-2",
            color: "grey",
            name: "NO COMPLETADO",
          };
        case "PENDIENTE":
          return {
            background: "blue lighten-5",
            color: "blue",
            name: "PENDIENTE",
          };
        case "OBSERVADO":
          return {
            background: "yellow lighten-4",
            color: "yellow darken-2",
            name: "OBSERVADO",
          };
      }
    },

  },

  beforeDestroy() {
    this.cleanEvidenceActionPlanId();
  },

  components: {
    ObservedEvidenceDialog,
    EvidenceActionPlanDetailDialog
  }
}